import React from "react";

import { texts } from "../data/langs";
import feather from "feather-icons";
import "../App.css";

export const Testimonials = () => {
  const [highlightedIndex, setHighlightedIndex] = React.useState(0);

  const speechs = texts[texts.active].testimonials.speechs ?? [];

  React.useEffect(() => {
    const interval = setInterval(() => {
      const randomIndex = Math.floor(Math.random() * speechs.length);
      setHighlightedIndex(randomIndex);
    }, 8000); // 8 segundos

    return () => clearInterval(interval);
  }, [speechs.length]);

  return (
    <div id="Depoimentos" className="features">
      <section className="limiter">
        <div className="gradTxt">{texts[texts.active].testimonials.div}</div>

        <div className="GAP-H20" />

        <h1 className="limiter2">{texts[texts.active].testimonials.h1}</h1>
        <h3 className="limiter2">{texts[texts.active].testimonials.h3}</h3>

        <div className="GAP-H20" />
        <div className="GAP-H20" />

        <div className="features">
          {speechs.map((i, index) => {
            const isHighlighted = index === highlightedIndex;
            const defaultColorBG = "rgba(14, 14, 14, 0.8)";
            const defaultColorQuote = "#444";

            const activeColorBG = "rgba(38, 28, 221, 0.8)";
            const activeColorQuote = "#0550ff";

            return (
              <>
                <a
                  key={index}
                  className="box_features"
                  style={{
                    paddingLeft: 60,
                    position: "relative",
                    backgroundColor: isHighlighted
                      ? activeColorBG
                      : defaultColorBG,
                  }}
                  // href="https://play.google.com/store/apps/details?id=com.sergirafa"
                >
                  <span
                    style={{
                      fontSize: 64,
                      position: "absolute",
                      color: isHighlighted
                        ? activeColorQuote
                        : defaultColorQuote,
                      top: 20,
                      left: 20,
                    }}
                  >
                    "
                  </span>

                  <span className="box_title">{i.speech}</span>

                  <div className="GAP-H20" />
                  <div className="GAP-H20" />

                  <span className="box_title">{i.client}</span>
                  <span className="box_text">{"Projeto:" + " " + i.work}</span>
                </a>
                <div className="GAP-20" />
              </>
            );
          })}
        </div>
      </section>
    </div>
  );
};
